import deployStatuses from 'relevant-shared/misc/deployStatuses';
/**
 * "Done" in this case means success, error or stopped.
 */
export function isDeployDone(state) {
	return state.status === deployStatuses.SUCCESS
		|| state.status === deployStatuses.STOPPED
		|| state.status === deployStatuses.FAILED;
}
